import { render, staticRenderFns } from "./BookList.vue?vue&type=template&id=17478731&scoped=true&"
import script from "./BookList.vue?vue&type=script&lang=js&"
export * from "./BookList.vue?vue&type=script&lang=js&"
import style0 from "./BookList.vue?vue&type=style&index=0&id=17478731&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17478731",
  null
  
)

export default component.exports